import React from 'react';
import { Card, CardContent } from '@/shared/ui/card';
import { Link } from '@/shared/ui';

interface ContactCardProps {
  href: string;
  icon: React.ReactElement | string;
  title: string;
  description: string;
}

// React Aria's Link handles routing (same-origin goes through the router,
// everything else natively), but not whether to open a new tab. Only http(s)
// should — mailto: and tel: hand off to another app and must stay in place.
const opensInNewTab = (href: string) => /^https?:/i.test(href);

export const ContactCard: React.FC<ContactCardProps> = ({
  href,
  icon,
  title,
  description,
}) => {
  return (
    <Card className="group h-full hover:shadow-md">
      <CardContent className="h-full p-6">
        <Link
          href={href}
          target={opensInNewTab(href) ? '_blank' : undefined}
          rel={opensInNewTab(href) ? 'noopener noreferrer' : undefined}
          className="flex h-full items-center gap-4 text-foreground hover:text-foreground"
        >
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg border bg-muted text-2xl">
            {icon}
          </div>
          <div className="min-w-0 flex-1 space-y-1">
            <h3 className="font-semibold">{title}</h3>
            <p className="text-sm break-words text-muted-foreground">
              {description}
            </p>
          </div>
        </Link>
      </CardContent>
    </Card>
  );
};
